import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * Recipe for TextBanner module:
 * variants:
 *  - colorWorld: fjordBlue | cherry | pineGreen | terracotta | malva | sunflower
 */

export default defineSlotRecipe({
    slots: ['root', 'contentContainer', 'copyWrapper', 'ctaWrapper'],
    base: {
        root: {
            borderRadius: 'xs',
            backgroundColor: 'background.section.strong',
            color: 'text.primary',
            paddingBlock: 'spacing-20',
            paddingInline: 'spacing-16'
        },
        contentContainer: {
            display: 'flex',
            flexDirection: {base: 'column', s: 'row'},
            alignItems: {base: 'flex-start', s: 'center'},
            gap: {base: 'spacing-12', s: 'spacing-16'}
        },
        copyWrapper: {
            flex: 1,
            textStyle: 'body.small',
            textAlign: 'left'
        },
        ctaWrapper: {
            flexShrink: 0,
            alignSelf: {base: 'flex-start', s: 'center'},
            // Override CTA button size to small within TextBanner
            '& button': {
                size: 'sm'
            }
        }
    },
    variants: {
        colorWorld: {
            fjordBlue: {
                root: {
                    backgroundColor: 'secondary.fjordBlue',
                    color: 'primary.base.white'
                }
            },
            cherry: {
                root: {
                    backgroundColor: 'secondary.cherry',
                    color: 'primary.base.white'
                }
            },
            pineGreen: {
                root: {
                    backgroundColor: 'secondary.pineGreen',
                    color: 'primary.base.white'
                }
            },
            terracotta: {
                root: {
                    backgroundColor: 'secondary.terracotta',
                    color: 'primary.base.white'
                }
            },
            malva: {
                root: {
                    backgroundColor: 'secondary.malva',
                    color: 'primary.base.white'
                }
            },
            sunflower: {
                root: {
                    backgroundColor: 'secondary.sunflower',
                    color: 'primary.base.black'
                }
            }
        }
    }
})
